import { render, staticRenderFns } from "./modelSelector.vue?vue&type=template&id=08e4cf5c&"
import script from "./modelSelector.vue?vue&type=script&lang=ts&"
export * from "./modelSelector.vue?vue&type=script&lang=ts&"
import style0 from "./modelSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports